import { useEffect, useRef, useState } from 'react';

function CounterNumber({ value }) {
    const [count, setCount] = useState(0);
    const elementRef = useRef(null);
    const animationRef = useRef(null);

    // Extract number and suffix (%, x, etc.)
    const numericValue = parseFloat(value);
    const suffix = value.replace(/[0-9.]/g, '');

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // Start animation
                        const duration = 2000;
                        const steps = 60;
                        const increment = numericValue / steps;
                        let current = 0;
                        
                        if (animationRef.current) {
                            clearInterval(animationRef.current);
                        }
                        
                        animationRef.current = setInterval(() => {
                            current += increment;
                            if (current >= numericValue) {
                                setCount(numericValue);
                                clearInterval(animationRef.current);
                            } else {
                                setCount(current);
                            }
                        }, duration / steps);
                    } else {
                        // Reset when out of view
                        if (animationRef.current) {
                            clearInterval(animationRef.current);
                        }
                        setCount(0);
                    }
                });
            },
            { threshold: 0.5 }
        );

        if (elementRef.current) {
            observer.observe(elementRef.current);
        }

        return () => {
            observer.disconnect();
            if (animationRef.current) {
                clearInterval(animationRef.current);
            }
        };
    }, [numericValue]);

    const displayValue = suffix === 'x' 
        ? `${Math.round(count)}${suffix}`
        : `${Math.round(count)}${suffix}`;

    return <span ref={elementRef}>{displayValue}</span>;
}

export default CounterNumber;
